import { Component, OnInit } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { Router } from '@angular/router';
import { MunicipalityService } from '../core/municipality.service';
import { MunicipalityHeaderComponent } from '../shared/municipality-header/municipality-header.component';

@Component({
  selector: 'app-services-landing',
  standalone: true,
  templateUrl: './services-landing.component.html',
  imports: [NgIf, AsyncPipe, TranslatePipe, ButtonDirective, MunicipalityHeaderComponent],
})
export class ServicesLandingComponent implements OnInit {
  current$ = this.municipalityService.current$;

  constructor(
    private municipalityService: MunicipalityService,
    public translate: TranslateService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // If user lands here directly (e.g. via refresh) without a selected municipality,
    // redirect to home after initial navigation stabilizes to avoid constructor-time navigation glitches.
    if (!this.municipalityService.getCurrent()) {
      // Defer to next microtask and replace current URL to prevent a blank screen on hard refresh
      Promise.resolve().then(() => this.router.navigate(['/'], { replaceUrl: true }));
    }
  }

  switchLanguage(lang: 'en' | 'it') {
    this.translate.use(lang);
  }

  bookAppointment() {
    // Navigate to the appointment booking screen; the screen will read the selected municipality
    this.router.navigateByUrl('/appointments');
  }

  // If user lands here without selection, send them back to home
  onNoSelection() {
    this.router.navigateByUrl('/');
  }
}
